import { Factory } from "./../core/factory";

import { BaseMark } from "./base/base-mark";

import { registerRectAnimation } from "../animation/config";

import { registerRectDataLabel } from "@visactor/vrender-components/label";

import { createRect, registerRect, registerShadowRoot } from "../vrender-bridge";

export class RectMark extends BaseMark {
    constructor() {
        super(...arguments), this.type = RectMark.type;
    }
    _getDefaultStyle() {
        return Object.assign(Object.assign({}, super._getDefaultStyle()), {
            width: void 0,
            height: void 0,
            lineWidth: 0
        });
    }
}

RectMark.type = "rect";

export const registerRectMark = () => {
    registerShadowRoot(), registerRect(), registerRectDataLabel(), Factory.registerMark(RectMark.type, RectMark), 
    registerRectAnimation(), Factory.registerGraphicComponent("rect", createRect);
};
//# sourceMappingURL=rect.js.map
